<template>
    <div class="home">
        <el-container style="height: 100%;">
            <el-header style="height: 4%; display: flex;justify-content: space-between;">
                <div style="display: flex;gap:10px;width: 320px;">
                    <img src="../assets/favicon.png" alt="">
                    <div class="header-text-left">凌丰供应商系统</div>
                    <div class="pe-header-text"></div>
                </div>
                <div class="nav" style="line-height: 40px">
                </div>
                <div style="width: 320px;">
                    <div class="header-right">欢迎您，{{ userNme }} ({{ roleName }}) </div>
                    <div class="header-right" style="color: #fff;">{{ homeDate }}</div>
                </div>

            </el-header>
            <div style="text-align:left;padding-left: 20px;">
                <h3 style="margin:10px">供应商门户管理</h3>
                <div class="nav_1">
                    <el-input filterable clearable style="width:250px" v-model="searchobj.userName" size="small"
                        placeholder="请输入用户名" @change="senior_search"></el-input>
                    <el-select filterable clearable style="width:250px" v-model="searchobj.roleId" size="small"
                        placeholder="请选择用户类型" @change="senior_search">
                        <el-option v-for="item in roleList" :key="item.id" :label="item.name"
                            :value="item.id"></el-option>
                    </el-select>
                    <el-select style="width: 250px;font-size: 14px;" size="small" clearable filterable remote
                        v-model="searchobj.supplierId" placeholder="选择供应商" :remote-method="async_supplier"
                        @change="senior_search" :loading="loading2" default-first-option>
                        <el-option v-for="item in supplier_options" :key="item.id" style="width:100%"
                            :label="item.supplierName" :value="item.id">
                        </el-option>
                    </el-select>
                    <el-button @click="reset" size="small" style="margin-left: 20px;" type="primary"
                        plain>重置</el-button>
                    <el-button @click="senior_search" size="small" style="margin-left: 10px;" type="primary"
                        plain>搜索</el-button>
                    <el-button @click="senior_search" size="small" style="margin-left: 10px;" type="primary"
                        plain>刷新</el-button>
                    <el-button @click="addUserShow = true" size="small" style="margin-left: 10px;" type="success"
                        plain>新增</el-button>
                </div>
            </div>
            <el-main style="height: 94%;padding: 0;text-align: left;">
                <div class="table-body">
                    <el-table ref="multipleTable" :data="table_data" border height="100%"
                        :header-row-style="{ height: '0' }"
                        :header-cell-style="{ background: '#fff', color: '#000', padding: '0' }"
                        :row-style="{ height: '0' }" :cell-style="{ padding: '2px 0' }" row-key="formId"
                        v-loading="table_loading">
                        <el-table-column label="序号" width="50" align="center">
                            <template slot-scope="{ $index }">
                                <span>{{ $index + 1 }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="用户名称" prop="userName" width="auto" align="center"
                            sortable></el-table-column>
                        <el-table-column label="账号" prop="nickName" width="auto" align="center"
                            sortable></el-table-column>
                        <el-table-column label="用户类型" prop="roleId" width="auto" align="center" sortable>
                            <template slot-scope="scope">
                                <el-tag v-if="scope.row.roleId"
                                    :type="typeList[roleList.findIndex(item => item.id == scope.row.roleId)]"
                                    size="mini" style="font-size: 14px;">{{
                                        (roleList.find(item => item.id == scope.row.roleId)).name}}</el-tag>
                            </template>
                        </el-table-column>
                        <el-table-column label="供应商名称" prop="supplier.supplierName" width="auto" align="center"
                            v-if="roleName != '供应商'" sortable></el-table-column>
                        <el-table-column label="供应商编号" prop="supplier.supplierCode" width="auto" align="center"
                            v-if="roleName != '供应商'" sortable></el-table-column>
                        <el-table-column align="center" width="210" label="操作">
                            <template slot-scope="scope">
                                <el-button size="mini" type="primary" plain @click="editUser(scope.row)">编辑</el-button>
                                <el-button size="mini" type="danger" plain @click="delUser(scope.row)">删除</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
                <div class="table-footer">
                    <el-pagination background layout="sizes, prev, pager, next" :total="totalPage"
                        @size-change="handleSizeChange" @current-change="change_data"
                        :current-page="searchobj.currentPage" :page-size="searchobj.pageSize">
                    </el-pagination>
                </div>
            </el-main>

            <el-dialog title="新增用户" :visible.sync="addUserShow" width="25%" :close-on-click-modal="false">
                <el-form ref="addUser" :model="addUserData" :rules="rules" label-width="100px" size="small">
                    <el-form-item label="用户名" prop="userName">
                        <el-input v-model="addUserData.userName" style="width: 80%;" clearable size="small">
                        </el-input>
                    </el-form-item>
                    <el-form-item label="账号" prop="nickName">
                        <el-input v-model="addUserData.nickName" style="width: 80%;" clearable size="small">
                        </el-input>
                    </el-form-item>
                    <el-form-item label="密码" prop="password">
                        <el-input type="password" v-model="addUserData.password" style="width: 80%;" clearable
                            size="small">
                        </el-input>
                    </el-form-item>
                    <el-form-item label="重复密码" prop="password2">
                        <el-input type="password" v-model="addUserData.password2" style="width: 80%;" clearable
                            size="small">
                        </el-input>
                    </el-form-item>
                    <el-form-item label="用户类型" prop="roleId">
                        <el-select filterable clearable style="width:80%" v-model="addUserData.roleId" size="small"
                            placeholder="请选择用户类型">
                            <el-option v-for="item in roleList" :key="item.id" :label="item.name"
                                :value="item.id"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="所属供应商" prop="supplierId">
                        <el-select style="width: 80%;" size="small" clearable filterable remote
                            v-model="addUserData.supplierId" placeholder="选择供应商" :remote-method="async_supplier"
                            :loading="loading2" default-first-option>
                            <el-option v-for="item in supplier_options" :key="item.id" style="width:100%"
                                :label="item.supplierName" :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-form>
                <div slot="footer" class="dialog-footer">
                    <el-button size="small" @click="addUserShow = false">取 消</el-button>
                    <el-button type="success" plain size="small" @click="addUserSubmit">确 定</el-button>
                </div>
            </el-dialog>

            <el-dialog title="修改用户" :visible.sync="editUserShow" width="25%" :close-on-click-modal="false">
                <el-form ref="editUser" :model="editUserData" :rules="rules" label-width="100px" size="small">
                    <el-form-item label="用户名" prop="userName">
                        <el-input v-model="editUserData.userName" style="width: 80%;" clearable size="small">
                        </el-input>
                    </el-form-item>
                    <el-form-item label="账号" prop="nickName">
                        <el-input v-model="editUserData.nickName" style="width: 80%;" clearable size="small">
                        </el-input>
                    </el-form-item>
                    <el-form-item label="用户类型" prop="roleId">
                        <el-select filterable clearable style="width:80%" v-model="editUserData.roleId" size="small"
                            placeholder="请选择用户类型">
                            <el-option v-for="item in roleList" :key="item.id" :label="item.name"
                                :value="item.id"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="所属供应商" prop="supplierId">
                        <el-select style="width: 80%;" size="small" clearable filterable remote value-key="id"
                            v-model="editUserData.supplier" placeholder="选择供应商" :remote-method="async_supplier"
                            :loading="loading2" default-first-option>
                            <el-option v-for="item in supplier_options" :key="item.id" style="width:100%"
                                :label="item.supplierName" :value="item">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-form>
                <div slot="footer" class="dialog-footer">
                    <el-button size="small" @click="editUserShow = false">取 消</el-button>
                    <el-button type="success" plain size="small" @click="editUserSubmit">确 定</el-button>
                </div>
            </el-dialog>
            <el-footer style="height: 2%; font-size: 13px;color: #fff;">© 2024 LINKFAIRTECH 版权所有</el-footer>
        </el-container>


    </div>
</template>

<script>
import * as userApi from '@/Api/userApi'
import { get_supplier } from '@/utils/func'
export default {
    name: 'userManager',
    components: {
    },
    data() {
        let validateNewPassword = (rule, value, callback) => {
            if (value.length > 16) {
                callback(new Error('新密码设置的长度不能超过16位'))
            } else {
                callback()
            }
        }
        let validateNewPassword2 = (rule, value, callback) => {
            if (value !== this.addUserData.password) {
                callback(new Error('密码两次输入不一致'))
            } else if (value.length > 16) {
                callback(new Error('密码设置的长度不能超过16位'))
            } else {
                callback()
            }
        }
        return {
            homeDate: '',
            userNme: sessionStorage.getItem('userName'),
            searchobj: {
                id: '',
                userName: '',
                roleId: '',
                supplierId: '',
                pageSize: 100,
                currentPage: 1,
            },
            loading2: false,
            supplier_options: [],
            header: {
                headers: { token: sessionStorage.getItem('token') }
            },
            table_data: [],
            table_loading: false,
            totalPage: 0,
            roleName: sessionStorage.getItem('roleName'),
            roleList: [
                { id: 'admin', name: '管理员' },
                { id: 'ordinary', name: '普通用户' },
                { id: 'supplier', name: '供应商' },
                { id: 'treasurer', name: '财务员' },
                { id: 'warehouse', name: '仓管员' },
            ],
            roleNameList: ['管理员', '', '', '', ''],
            typeList: ['success', 'info', '', 'warning', 'danger'],
            addUserShow: false,
            addUserData: {
                userName: '',
                nickName: '',
                password: '',
                password2: '',
                roleId: '',
                supplierId: '',
            },
            editUserShow: false,
            editUserData: {},
            rules: {
                userName: [
                    { required: true, message: '必填项', trigger: ['blur', 'change'] }
                ],
                nickName: [
                    { required: true, message: '必填项', trigger: ['blur', 'change'] }
                ],
                password: [
                    { required: true, message: '必填项', trigger: 'blur' },
                    { validator: validateNewPassword, trigger: 'blur' }
                ],
                password2: [
                    { required: true, message: '必填项', trigger: 'blur' },
                    { validator: validateNewPassword2, trigger: 'blur' }
                ],
                roleId: [
                    { required: true, message: '必填项', trigger: ['blur', 'change'] }
                ],
                // supplierId: [
                //     { required: true, message: '必填项', trigger: ['blur', 'change'] }
                // ],
            }
        }
    },
    computed: {

    },
    methods: {
        //显示时间
        showTime() {
            setTimeout(() => {
                this.showTime();
            }, 1000);
            this.homeDate = this.$getTime()
        },
        //页码发生变化时
        change_data(e) {
            this.searchobj.currentPage = e
            this.senior_search()
        },
        //修改每页大小
        handleSizeChange(e) {
            this.searchobj.pageSize = e
            this.searchobj.currentPage = 1
            this.senior_search()
        },
        senior_search() {
            userApi.userQuery(this.searchobj, this, true).then(res => {
                this.table_data = res.records
                this.totalPage = res.total
            }).catch(() => { })
        },
        async_supplier(query) {
            get_supplier(this, query)
        },
        reset() {
            this.searchobj.roleId = ''
            this.searchobj.userName = ''
            this.searchobj.supplierId = ''
        },
        addUserSubmit() {
            this.$refs.addUser.validate(valid => {
                if (valid) {
                    let submitData = structuredClone(this.addUserData)
                    delete submitData.password2
                    userApi.addUser(submitData, this, true).then(res => {
                        this.$message.success('添加成功')
                        this.senior_search()
                        this.addUserShow = false
                    }).catch(() => { })
                }
            })
        },
        editUser(row) {
            this.editUserData = JSON.parse(JSON.stringify(row))
            if (this.editUserData.supplier == null) this.editUserData.supplier = ''
            this.supplier_options = [this.editUserData.supplier]
            this.editUserShow = true
        },
        editUserSubmit() {
            this.$refs.editUser.validate(valid => {
                if (valid) {
                    let submitData = JSON.parse(JSON.stringify(this.editUserData))
                    submitData.supplierId = submitData.supplier.id
                    delete submitData.supplier
                    userApi.updateUser(submitData, this, true).then(res => {
                        this.$message.success('更新成功')
                        this.editUserShow = false
                        this.senior_search()
                    }).catch(() => { })
                }
            })
        },
        delUser(row) {
            this.$confirm('确认删除该用户？</br>用户名：' + row.userName + '</br>帐号：' + row.nickName, '提示', {
                confirmButtonText: '确认',
                cancelButtonText: '取消',
                type: 'warning',
                dangerouslyUseHTMLString: true
            }).then(() => {
                userApi.deleteUser({ userId: row.id }, this, true).then(() => {
                    this.$message.success('删除成功')
                    this.senior_search()
                }).catch(() => { })
            }).catch(() => { })
        },
    },
    mounted() {
        this.showTime()
    },
    created() {
        this.senior_search()
    }
}
</script>
<style>
.home {
    height: 100%;
}

.el-header {
    background-color: #12b4bd;
}

.nav_1 {
    display: flex;
}

.nav_1>* {
    margin-left: 20px;
}

.el-main {
    background-color: #ccc;
}

.el-footer {
    background-color: #12b4bd;
}

.el-table__body tr:hover>td {
    background-color: #c0ddaf !important;
}

.table-body .selected-row {
    background-color: #c0ddaf;
}

.nav .el-button {
    border-color: #12b4bd;
    color: #12b4bd;
}

.table-body .el-table .el-checkbox {
    transform: scale(1.5);
    /* 使用transform缩放选择框 */
}
</style>
<style scoped>
.header-text-left {
    height: 38px;
    line-height: 38px;
    font-size: 22px;
    font-weight: 700;
    color: #fff;
}

.pe-header-text {
    margin-left: 12px;
    font-size: 16px;
    font-weight: 600;
    line-height: 45px;
    color: rgba(255, 255, 255, 0.9);
}

.header-right {
    font-size: 13px;
    height: 19px;
    line-height: 25px;
    text-align: right;
    padding-right: 15px;
    color: rgba(255, 255, 255, 0.85);
}

.header-right:first-child {
    font-weight: 500;
}

.el-form-item {
    margin-bottom: 12px;
}

.table-body {
    height: 95%;
    padding: 15px;
}

.table-footer {
    height: 5%;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #fff;
    border-top: 1px solid #f0f0f0;
}
</style>